import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import { CompanionSplitScreenService } from '@nimbus-library/features/companion-chat/services/companion-split-screen.service';

// When split-screen is active, intercepts navigation to the chat route and triggers the expand flow instead of allowing a duplicate chat instance in the router outlet.
// On the initial page load (refresh/direct URL), split screen is deactivated and navigation proceeds normally.
export const companionSplitScreenExpandGuard: CanActivateFn = (): boolean => {
  const service = inject(CompanionSplitScreenService);
  const router = inject(Router);

  if (service.isActive) {
    if (!router.navigated) {
      service.deactivate();
      return true;
    }
    service.requestExpand();
    return false;
  }

  return true;
};
